import * as React from 'react';
import Slider from 'rc-slider';
import { RadioGroup, RadioButton } from 'react-radio-buttons';
import renderHTML from 'react-render-html';
import { SectorsEarningsChart } from './SectorsEarningsChart';
import {
    numberRound, inWords_ThreeYears, getTotalEmployees, getSectorCount, getSectorWage, getSectorEmploymentText
} from '../../Common/Helpers';

import { EmployeeReportState, SelectionState } from '../../../interface/EmployeeReportInterface';
import { UserState } from '../../../interface/MyInterfaces';

import { setTab2_bullets } from '../../../actions/EmployeeReportActions'

//track use visit
import { withUserActionTracker } from './../../../sharedUtilities/UserActionTracker';

interface TheseProps {
    setTab2_bullets?(year, type, EmployeeProfile2, EmployeeProfileInfo, display_id);
}

class SectorsEarningsTab extends React.Component<EmployeeReportState & UserState & TheseProps, SelectionState> {
    constructor(props) {
        super(props);
        this.state = {
            slider_year: 1,
            selected_employee_type: this.getDefaultType(this.props.EmployeeProfile2)
        };
        this.onYearChange = this.onYearChange.bind(this);
        this.onEmployeeTypeChange = this.onEmployeeTypeChange.bind(this);
    }

    getDefaultType = (empProfile) => {
        const allSum = empProfile.filter(d => d.employee === 'All').reduce((acc, cur) => acc += cur.count, 0);
        const postDocSum = empProfile.filter(d => d.employee === 'Postdoctoral').reduce((acc,cur)=>acc+=cur.count,0);
        const gradStudentSum = empProfile.filter(d => d.employee === 'Graduate Student').reduce((acc, cur) => acc += cur.count, 0);
        if (allSum > 0) return "All";
        return (allSum===0 && postDocSum === 0 && gradStudentSum === 0) ? 'Other' : 'Graduate Student';
    }
    
    bullets() {
        if (this.props.EmployeeReport_Tab2 !== undefined) {
            return (
                <div>{this.props.EmployeeReport_Tab2 && renderHTML(this.props.EmployeeReport_Tab2.bullets)}</div>
            );
        }
        return <div>loading <i className="fa fa-spinner"></i></div>;
    }

    onYearChange(value) {
        this.setState({
            slider_year: value,
        });
        this.props.setTab2_bullets(value, this.state.selected_employee_type, this.props.EmployeeProfile2, this.props.EmployeeProfileInfo, this.props.display_id);
    }

    onEmployeeTypeChange(value) {
        this.setState({
            selected_employee_type: value,
        });
        this.props.setTab2_bullets(this.state.slider_year, value, this.props.EmployeeProfile2, this.props.EmployeeProfileInfo, this.props.display_id);
    }

    marks(selected_year) {
        var marks_array = {};
        var i = 1;
        for (i = 1; i <= this.props.EmployeeReport_Tab2.max_year; i++) {
            if (i == selected_year)
                marks_array[i] = <strong>{i}-{(i + 2)}</strong>;
            else
                marks_array[i] = i + '-' + (i + 2);
        }

        var one = {
            1: '1-3',
            2: <strong>2-4</strong>,
            3: '3-5',
            4: '4-6',
            5: '5-7',
            6: '6-8',
            7: '7-9',
            8: '8-10',
            9: '9-11',
            10: '10-12'
        }

        return marks_array;

    };

    public render() {
        const census_logo = require('../../../images/censusLogo.png');

        let logoUni;
        try {
            logoUni = require(`../../../images/univ_logos/${this.props.display_id}.png`);
        }
        catch (err) {

        }
        const categories = [...new Set(this.props.EmployeeProfile2.map(x => x.employee.trim()))];
        categories.sort((a, b) => { //make category All the first and Other the last
            if (a == "Other") {
                return 1;
            }
            if (b == "Other") {
                return -1;
            }
            return a.charAt(0) > b.charAt(0)? 1 : -1;
        });
        return (
            <div className='tabcontents container-fluid'>
                <div className="row">
                    <div className="col-md-10">
                        <h1><span>{this.props.EmployeeProfileInfo && this.props.EmployeeProfileInfo.university} Employee Profile Report</span>:</h1>
                        <h3>Sectors and Earnings</h3>
                    </div>
                    <div className="report__logo">{logoUni &&
                        <img height='80px' src={String(logoUni)} alt='Logo'></img>
                    }
                    </div>
                </div>
                <div className='row'>
                    <div className="col-md-12">
                        <h4 style={{ textAlign: 'justify', marginBottom:"10px" }}>The Sectors and Earnings tab displays the average yearly earnings for certain groups of research-trained employees in the years following their departure from {this.props.agg ? `their home universities` : `your university`}. These earnings are displayed in three-year averages based on the period of time after employees leave the university. You can opt to view information separately for graduate students, postdoctoral trainees, as well as for staff members. By selecting employee types and time period, a user can see how average education, public, or private-sector earnings vary over time for specific groups of research-trained employees.</h4>
                        <h4>In what sectors do your research-trained individuals work and how much do they earn?</h4>
                        {this.props.EmployeeReport_Tab2 && <div className="years">
                            <span style={{ marginRight: "20px" }}>Years since leaving your university</span>{/*this.props.EmployeeReport_Tab2.min_year*/}
                            <Slider marks={this.marks(this.state.slider_year)} onChange={this.onYearChange} className="year_slider" dots={true} step={1} min={this.props.EmployeeReport_Tab2.min_year} max={this.props.EmployeeReport_Tab2.max_year} />{/*this.props.EmployeeReport_Tab2.max_year*/}
                        </div>}
                        <br />
                        <div className="typeFilter">
                            <RadioGroup value={this.state.selected_employee_type} name="type" onChange={this.onEmployeeTypeChange} horizontal>
                                {categories.map((category) => {
                                    const radioBtnText = category == "Graduate Student" ? "Graduate Students"
                                        : category == "Postdoctoral" ? "Post Docs" : category == "Other" ? "Other (Staff)" : category;
                                return <RadioButton pointColor="indigo" iconSize={20} iconInnerSize={10} padding={5} value={category}>{radioBtnText}</RadioButton>
                                })}
                            </RadioGroup>
                        </div>
                        <br />
                    </div>
                </div>

                <SectorsEarningsChart EmployeeProfile2={this.props.EmployeeProfile2} slider_year={this.state.slider_year} selected_employee_type={this.state.selected_employee_type} normal_or_large={0} />
                <div className="row">
                    <div className="col-md-12 sectors_bullets">{this.bullets()}</div>
                </div>

                <div className='row'>
                    <div className="col-md-12">
                        <img src={String(census_logo)} height='60' />
                    </div>
                </div>
            </div>);
    }
}

export default withUserActionTracker(SectorsEarningsTab, "Census Supplemental Employee Profile Report", "viewed Sector Earnings Tab");
